import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-gauge',
  templateUrl: './gauge.component.html',
  styleUrls: ['./gauge.component.scss']
})
export class GaugeComponent implements OnInit {

	@Input('max') max: number;	
	@Input('type') type: string ;
	@Input('value') value: number;
	@Input('title') title: string;
	@Input('title-position') position: string
  @Input('show-value') showValue: boolean
	startAngle: number
	endAngle: number
	percent: number 
	status: string
  constructor() { }

  ngOnInit() {  
  if (this.position ==undefined) {
      this.position = 'top'
    }	
    if (this.showValue ==undefined) {
      this.showValue = true
    }  
  	this.percent  =  (this.value*100)/this.max
  	switch (this.type) {
  		case "smallArch":
  			this.startAngle = 225
				this.endAngle = -45
  			break;

  		case "full":
  			this.startAngle = -90
				this.endAngle = -90.001
  			break;

      case "semi":
        this.startAngle = 180
        this.endAngle = 0  
        break;
  		
  		default:
  			break;
  	}  	
  }

  styleClass(){
  	this.percent  =  (this.value*100)/this.max
  	return (this.percent <= 40)?' success':(this.percent <= 80)?' warning':' danger';
  }

}
